import React, { useRef, useState, useCallback, useEffect } from "react";
import { SelectComponent } from "../../../components";
import Webcam from "react-webcam";
import Styles from "../styles/StylesForm";
import { customModal, topModal } from "../../../components/modals/utils";
import { fonts } from "../../../config";
import { alerts, hooks } from "../../../utils";
import { FormHelperText } from "@material-ui/core";
import { VideocamOff } from "@material-ui/icons";
import { api } from "../../../services";
import { FormFull } from "form-full";
// import { Camera } from "@mediapipe/camera_utils";
// import { FaceDetection } from "@mediapipe/face_detection";
// import { FaceMesh } from "@mediapipe/face_mesh";

// const getImageSize = async (dataUri) => {
//   const byteString = atob(dataUri.split(",")[1]);
//   const mimeString = dataUri.split(",")[0].split(":")[1].split(";")[0];
//   const ab = new ArrayBuffer(byteString.length);
//   const ia = new Uint8Array(ab);
//   for (let i = 0; i < byteString.length; i++) {
//     ia[i] = byteString.charCodeAt(i);
//   }
//   const blob = new Blob([ab], { type: mimeString });
//   return blob.size / 1024;
// };

function WebcamModal({ onSubmit, data }: { onSubmit: any; data?: any }) {
  const { loading, call } = hooks.useRequest();
  // const videoRef = useRef<HTMLVideoElement | null>(null);
  const webcamRef = useRef<
    | (Webcam & {
        getScreenshot: () => string;
      })
    | null
  >(null);
  const [imgSrc, setImgSrc] = useState<{ src: string; name: string } | null>(
    null
  );
  const [resImage, setResImage] = useState<number>(1);
  const [isCameraEnabled, setIsCameraEnabled] = useState(false);
  const [cameraLoading, setCameraLoading] = useState<boolean>(true);
  // const [faceDetected, setFaceDetected] = useState<string | null>(
  //   "Nenhum rosto detectado. Verifique se a iluminação está adequada."
  // );
  // const [faceDetectedAngle, setFaceDetectedAngle] = useState<string | null>(
  //   "Nenhum rosto detectado. Verifique se a iluminação está adequada."
  // );
  // const [captureCalled, setCaptureCalled] = useState<boolean>(false);

  const [resolution, setResolution] = useState<any>({
    width: 1080,
    height: 1620,
    ratio: 0.66666,
  });

  const cropImageEnabled = data.find((element) => element.type === "CROP_IMAGE_ENABLED")?.value === "true" || true;
  const cropImageMinWidth = Number(data.find((element) => element.type === "CROP_IMAGE_MIN_WIDTH")?.value || 200);
  const cropImageMinHeight = Number(data.find((element) => element.type === "CROP_IMAGE_MIN_HEIGHT")?.value || 300);
  const maxImageSize = Number(data.find((element) => element.type === "CROP_IMAGE_MAX_SIZE")?.value || 100); // in KB

  useEffect(() => {
    const getDevices = async () => {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(
        (device) => device.kind === "videoinput"
      );

      if (videoDevices.length > 0) {
        const constraints = {
          video: {
            deviceId: videoDevices[0].deviceId,
          },
        };

        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        const track = stream.getVideoTracks()[0];
        const settings = track.getSettings();

        if (settings.width != null && settings.height != null) {
          setResolution({
            width: settings.width,
            height: settings.height,
            ratio: settings.width / settings.height,
          });
        }
        setCameraLoading(false);
        track.stop();
      }
    };

    getDevices();
  }, []);
  
  // useEffect(() => {
  //   const videoElement = document.createElement("video");
  //   let lastLandmarks = null;
  //   let localFaceDetected = false;
  //   let localFaceDetectedAngle = false;
  //   let frameDetected = null;
  //   videoRef.current = videoElement;
  //   const faceDetection = new FaceDetection({
  //     locateFile: (file) =>
  //       `https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/${file}`,
  //   });

  //   faceDetection.setOptions({
  //     model: "short",
  //     minDetectionConfidence: 0.5,
  //   });

  //   const faceMesh = new FaceMesh({
  //     locateFile: (file) =>
  //       `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`,
  //   });

  //   faceMesh.setOptions({
  //     maxNumFaces: 1,
  //     refineLandmarks: true,
  //     minDetectionConfidence: 0.9,
  //     minTrackingConfidence: 0.9,
  //   });

  //   const onFaceDetectionResults = (results) => {
  //     if (results.detections.length === 1) {
  //       const face = results.detections[0].boundingBox;
  //       const faceX = face.xCenter;
  //       const faceY = face.yCenter;
  //       const faceHeight = face.height;

  //       const offsetX = Math.abs(faceX - 0.5);
  //       const offsetY = Math.abs(faceY - 0.5);

  //       const minX = 0.25,
  //         maxX = 0.75;
  //       const minY = 0.15,
  //         maxY = 0.85;
  //       const minSize = 0.3,
  //         maxSize = 0.4;

  //       const isCentered =
  //         faceX > minX &&
  //         faceX < maxX &&
  //         faceY > minY &&
  //         faceY < maxY &&
  //         offsetX < 0.1 &&
  //         offsetY < 0.1;

  //       const isSizedCorrectly = faceHeight > minSize && faceHeight < maxSize;

  //       if (isCentered) {
  //         if (!isSizedCorrectly) {
  //           localFaceDetected = false;
  //           setFaceDetected(
  //             faceHeight > maxSize
  //               ? "Afaste o seu rosto da câmera."
  //               : "Aproxime o seu rosto da câmera."
  //           );
  //         } else {
  //           frameDetected = results.image;
  //           localFaceDetected = true;
  //           setFaceDetected(null);
  //         }
  //       } else {
  //         localFaceDetected = false;
  //         setFaceDetected("Alinhe seu rosto com a elipse vermelha.");
  //       }
  //     } else if (results.detections.length > 1) {
  //       localFaceDetected = false;
  //       setFaceDetected("Mais de um rosto detectado.");
  //     } else {
  //       localFaceDetected = false;
  //       setFaceDetected(
  //         "Rosto não detectado ou qualidade de imagem ruim. Verifique se a iluminação está adequada."
  //       );
  //     }
  //   };

  //   const onFaceMeshResults = (results) => {
  //     if (
  //       !results.multiFaceLandmarks ||
  //       results.multiFaceLandmarks.length === 0
  //     ) {
  //       localFaceDetectedAngle = false;
  //       setFaceDetectedAngle(
  //         "Rosto não detectado ou qualidade de imagem ruim. Verifique se a iluminação está adequada."
  //       );
  //       return;
  //     }

  //     lastLandmarks = results.multiFaceLandmarks[0];

  //     if (!isLookingAtCamera(lastLandmarks)) {
  //       localFaceDetectedAngle = false;
  //       setFaceDetectedAngle("Olhe diretamente para a câmera.");
  //     } else {
  //       frameDetected = results.image;
  //       localFaceDetectedAngle = true;
  //       setFaceDetectedAngle(null);
  //     }
  //   };

  //   function isLookingAtCamera(landmarks) {
  //     if (!landmarks || landmarks.length < 468) {
  //       return false;
  //     }

  //     const leftEye = landmarks[33];
  //     const rightEye = landmarks[263];
  //     const nose = landmarks[1];

  //     if (!leftEye || !rightEye || !nose) {
  //       return false;
  //     }

  //     const eyeDistance = Math.abs(leftEye.x - rightEye.x);
  //     const noseOffset = Math.abs(nose.x - (leftEye.x + rightEye.x) / 2);

  //     return noseOffset < eyeDistance * 0.2;
  //   }

  //   faceDetection.onResults(onFaceDetectionResults);
  //   faceMesh.onResults(onFaceMeshResults);

  //   const camera = new Camera(videoElement, {
  //     onFrame: async () => {
  //       const canvas = document.createElement("canvas");
  //       canvas.width = 1080;
  //       canvas.height = 1620;
  //       const ctx = canvas.getContext("2d");

  //       if (ctx) {
  //         const videoWidth = videoElement.videoWidth;
  //         const videoHeight = videoElement.videoHeight;

  //         const videoRatio = videoWidth / videoHeight;
  //         const canvasRatio = canvas.width / canvas.height;

  //         let sx, sy, sWidth, sHeight;

  //         if (videoRatio > canvasRatio) {
  //           sHeight = videoHeight;
  //           sWidth = sHeight * canvasRatio;
  //           sx = (videoWidth - sWidth) / 2;
  //           sy = 0;
  //         } else {
  //           sWidth = videoWidth;
  //           sHeight = sWidth / canvasRatio;
  //           sx = 0;
  //           sy = (videoHeight - sHeight) / 2;
  //         }

  //         ctx.drawImage(
  //           videoElement,
  //           sx,
  //           sy,
  //           sWidth,
  //           sHeight,
  //           0,
  //           0,
  //           canvas.width,
  //           canvas.height
  //         );

  //         const frozenFrame = canvas.toDataURL("image/png");

  //         await faceDetection.send({ image: canvas });
  //         await faceMesh.send({ image: canvas });

  //         (async () => {
  //           // 🎯 2. ENVIA A IMAGEM CONGELADA PARA VERIFICAÇÃO
  //           await faceDetection.send({ image: canvas });
  //           await faceMesh.send({ image: canvas });

  //           if (
  //             localFaceDetected &&
  //             localFaceDetectedAngle &&
  //             isLookingAtCamera(lastLandmarks) &&
  //             !captureCalled
  //           ) {
  //             setCaptureCalled(true);

  //             // 🎯 3. SALVA O FRAME FIXO (em vez de capturar outro)
  //             setImgSrc({
  //               src: frozenFrame, // 🔹 Usa a imagem já capturada
  //               name: "user-photo",
  //             });

  //             // Download image for debuging
  //             // Se quiser baixar a imagem automaticamente, descomente o código abaixo
  //             // const downloadLink = document.createElement("a");
  //             // downloadLink.href = frozenFrame;
  //             // downloadLink.download = "captura.png";
  //             // document.body.appendChild(downloadLink);
  //             // downloadLink.click();
  //             // document.body.removeChild(downloadLink);

  //             camera.stop();
  //           }
  //         })();
  //       }
  //     },
  //     width: resolution.width,
  //     height: resolution.height,
  //   });

  //   camera.start();

  //   return () => {
  //     camera.stop();
  //   };
  // }, [captureCalled, resolution, cameraLoading]);

  function quality(image) {
    // Calculate image size in KB
      var validadeImageSize = image.length - ("data:image/jpeg;base64,".length);
      var sizeInBytes = 4 * Math.ceil((validadeImageSize / 3))*0.5624896334383812;
      var sizeInKb=sizeInBytes/1000;
      var sizeforKb = sizeInKb;

      for (let quality = 1.0; quality >= 0.1; quality -= 0.1) {
       sizeInKb = (sizeforKb * quality)
       if (sizeInKb <= maxImageSize) {

        // Debug: Log image size
        //console.log("Tamanho da Imagem: ", sizeInKb.toFixed(2), "KB  com qualidade de ", quality);

        return quality;
       }
      }
      
  }

  const capture = useCallback(async () => {
    const finalCanvas = document.createElement("canvas");

    finalCanvas.width = cropImageMinWidth;
    finalCanvas.height = cropImageMinHeight;
    
    const finalCtx = finalCanvas.getContext("2d");

    if (finalCtx && webcamRef.current?.video) {
      const videoElement = webcamRef.current.video;
      const videoWidth = videoElement.videoWidth;
      const videoHeight = videoElement.videoHeight;

      const videoRatio = videoWidth / videoHeight;
      const canvasRatio = finalCanvas.width / finalCanvas.height;

      let sx, sy, sWidth, sHeight;

      if (videoRatio > canvasRatio) {
        sHeight = videoHeight;
        sWidth = sHeight * canvasRatio;
        sx = (videoWidth - sWidth) / 2;
        sy = 0;
      } else {
        sWidth = videoWidth;
        sHeight = sWidth / canvasRatio;
        sx = 0;
        sy = (videoHeight - sHeight) / 2;
      }

      finalCtx.drawImage(
        videoElement,
        sx,
        sy,
        sWidth,
        sHeight,
        0,
        0,
        finalCanvas.width,
        finalCanvas.height
      );

      // Download image for debuging
      // const donwloadLink = document.createElement("a");
      // donwloadLink.href = finalCanvas.toDataURL("image/jpeg", quality(finalCanvas.toDataURL("image/jpeg", 1.0)));
      // donwloadLink.download = "captura.jpg";
      // document.body.appendChild(donwloadLink);
      // donwloadLink.click();
      // document.body.removeChild(donwloadLink);

      setImgSrc({
        src: finalCanvas.toDataURL("image/jpeg", quality(finalCanvas.toDataURL("image/jpeg", 1.0))),
        name: "user-photo",
      });
    }
  }, [webcamRef, resImage]);

  const sendData = () => {
    customModal.close();
    onSubmit(imgSrc);
  };
  
  // const savePcPhoto = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files?.[0];
  //   if (file) {
  //     if (file.size > 3 * 1024 * 1024) {
  //       alerts.alertWarning("Arquivo deve ser inferior a 3Mb");
  //     } else {
  //       const reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         setImgSrc({ src: e.target.result, name: file.name });
  //       };
  //       reader.readAsDataURL(file);
  //     }
  //   }
  // };

  const renderCapturedImage = () => (
    <div style={styles.container}>
      <div style={styles.instructions}>
        <div style={styles.bulletPoint}>
          <span style={styles.bullet}>•</span> Priorize fundos simples, de
          preferência branco e sem luzes;
        </div>
        <div style={styles.bulletPoint}>
          <span style={styles.bullet}>•</span> Enquadre bem a região do seu
          rosto, acima do peitoral e ombros;
        </div>
        <div style={styles.bulletPoint}>
          <span style={styles.bullet}>•</span> Evite luzes superiores que causem
          projeções de sombra em seu rosto;
        </div>
      </div>
      <div
        style={{
          ...styles.imagePreview,
          backgroundImage: imgSrc ? `url(${imgSrc.src})` : "",
        }}
      ></div>
      <div style={styles.actions}>
        <Styles.BackPhoto
          fullWidth={false}
          onClick={() => {
            setImgSrc(null);
            // setCaptureCalled(false);
          }}
        >
          Voltar
        </Styles.BackPhoto>
        <Styles.SendForm
          fullWidth={false}
          onClick={sendData}
          style={{
            backgroundColor: "red",
            borderColor: "red",
            borderStyle: "solid",
            borderWidth: "2px",
          }}
        >
          Confirmar
        </Styles.SendForm>
      </div>
      {/*  <Styles.BackPhoto
        fullWidth={true}
        onClick={debugPhoto}
        style={{
          color: "green",
          borderStyle: "solid",
          borderWidth: "2px",
        }}
      >
        Debug Baixar
      </Styles.BackPhoto> */}
    </div>
  );

  const svgIcon = () => (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: "50%",
        transform: "translate(-50%, 0%)",
        width: "fit-content", // Largura baseada no contêiner pai
        height: "100%", // Altura baseada na largura para manter a proporção
        aspectRatio: "9 / 12", // Define manualmente a proporção do oval
        display: isCameraEnabled ? "block" : "none",
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "50%", // Largura baseada no contêiner pai
          height: "50%", // Altura baseada na largura para manter a proporção
          aspectRatio: "9 / 12", // Define manualmente a proporção do oval
          transform: "translate(-50%, -50%)",
          border: "3px solid red",
          borderRadius: "50% / 65%", // Mantém o formato oval natural
          pointerEvents: "none",
        }}
      ></div>
    </div>
  );

  const renderCamera = () => (
    <div style={styles.container}>
      <div style={styles.instructions}>
        <div style={styles.bulletPoint}>
          <span style={styles.bullet}>•</span> Priorize fundos simples, de
          preferência branco e sem luzes;
        </div>
        <div style={styles.bulletPoint}>
          <span style={styles.bullet}>•</span> Enquadre bem a região do seu
          rosto, acima do peitoral e ombros;
        </div>
        <div style={styles.bulletPoint}>
          <span style={styles.bullet}>•</span> Evite luzes superiores que causem
          projeções de sombra em seu rosto;
        </div>
      </div>
      {!isCameraEnabled && (
        <div style={styles.cameraDisabled}>
          <VideocamOff style={styles.icon} />
        </div>
      )}

      {/* <p style={{ fontSize: "16px", color: "red", fontWeight: "bold" }}>
        {isCameraEnabled && (faceDetected || faceDetectedAngle)
          ? faceDetected || faceDetectedAngle
          : ""}
      </p> */}
      <div
        className="webcam-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          width: "100%",
          objectFit: "fill",
          maxWidth: "900px",
          maxHeight: "1000px",
          aspectRatio: 1080 + "/" + 1620,
        }}
      >
        <Webcam
          id="webcam"
          mirrored
          screenshotQuality={resImage}
          screenshotFormat="image/jpeg"
          width={resolution.width}
          height={resolution.height}
          videoConstraints={{
            width: resolution.width,
            height: resolution.height,
            aspectRatio: resolution.width / resolution.height,
            facingMode: "user",
          }}
          style={{
            ...styles.webcam,
            display: isCameraEnabled ? "block" : "none",
            aspectRatio: 1080 + "/" + 1620,
          }}
          audio={false}
          ref={webcamRef}
          onUserMedia={() => setIsCameraEnabled(true)}
          onUserMediaError={() => setIsCameraEnabled(false)}
        />
        {svgIcon()}
      </div>

      <div style={styles.actions}>
        <Styles.BackPhoto fullWidth={false} onClick={customModal.close}>
          Voltar
        </Styles.BackPhoto>
        <Styles.SendPhoto fullWidth={false} onClick={capture}>
          Tirar Foto
        </Styles.SendPhoto>
      </div>
    </div>
  );

  return imgSrc?.src ? renderCapturedImage() : renderCamera();
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    paddingInline: "20px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  instructions: {
    marginBottom: "10px",
    marginLeft: "5px",
    textAlign: "left",
    color: "white",
  },
  bulletPoint: {
    display: "flex",
    marginBottom: "5px",
  },
  bullet: {
    marginRight: "5px",
    fontSize: "16px",
  },
  imagePreview: {
    borderRadius: "5px",
    maxHeight: "80vh",
    minHeight: "300px",
    maxWidth: "80vw",
    height: "100%",
    width: "900px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
  },
  cameraDisabled: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#8D9B9C",
    borderRadius: "5px",
    maxHeight: "80vh",
    maxWidth: "80vw",
    height: "100%",
    width: "900px",
    minHeight: "300px",
  },
  icon: {
    fontSize: "48px",
    color: "#fff",
  },
  webcam: {
    borderRadius: "5px",
    maxWidth: "1000px",
    maxHeight: "100%",
    objectFit: "cover",
    width: "100%",
    height: "100%",
    aspectRatio: "1080/1620",
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    paddingTop: "10px",
    gap: "8px",
    width: "100%",
  },
};

export default WebcamModal;